import {Component, Input, OnInit} from '@angular/core';
import {HttpService} from '../../../../../../core';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-property-inclusions',
    templateUrl: './property-inclusions.component.html',
    styleUrls: ['./property-inclusions.component.scss']
})
export class PropertyInclusionsComponent implements OnInit {
    @Input() project: any;
    @Input() property: any;

    items: any;
    itemsFromDB = {
        data: [
            {
                en: 'Kitchen',
                zh: '厨房',
                children: [
                    {
                        title: {
                            en: 'Carpet',
                            zh: '地毯'
                        },
                        content: {
                            en: 'lkdjslakjdlaskdjlasd',
                            zh: '阿斯科利到家啦是肯德基啊了'
                        }
                    }
                ]
            }
        ]
    };

    constructor(private httpService: HttpService, private toastrService: ToastrService) {
    }

    ngOnInit(): void {
        console.log(this.property);
        this.items = this.property.ext ? this.property.ext : {data: []};
        console.log(this.items);
        this.labelInclusionAsFromDB(this.items.data);
    }

    labelInclusionAsFromDB(inclusions) {
        if (inclusions.length > 0) {
            inclusions.map(m => {
                if (m.en && m.zh) {
                  m.saved = true;
                }
                if (m.children.length > 0) {
                    m.children.map(n => {
                      if (n.title.en && n.title.zh && n.content.en && n.content.zh) {
                        n.saved = true;
                      }
                    });
                }
            });
        }
    }

    createTempInclusion() {
        // const
        this.items.data.push({
            en: '',
            zh: '',
            children: []
        });
        console.log(this.items);
    }


    saveInclusion(inclusion, index) {
        console.log(inclusion);
        if (!inclusion.en || !inclusion.zh) {
            inclusion.submitted = true;
            return;
        }
        inclusion.saved = true;
        // update property ext
        // ....
        console.log(this.items);
        this.items.data.map(item => {
            delete item['saved'];
            delete item['submitted'];
        });
        this.updateExt();
        console.log(this.items);

        // console.log(this.items);
        // const fd = new FormData();
        // fd.append('id', this.property.id);
        // fd.append('ext', JSON.stringify(this.items));
        // this.httpService.updateProperty(this.property.id, fd).subscribe((res: any) => {
        //     console.log(res);
        //     if (res.code === 1) {
        //         this.toastrService.success('Property has been updated');
        //     } else {
        //         this.toastrService.error('Failed to update property');
        //     }
        //     this.labelInclusionAsFromDB(this.items.data);
        // });


    }

    discardTempInclusion(index) {
        this.items.data.splice(index, 1);
    }

    deleteInclusion(index) {
        this.items.data.splice(index, 1);
        // update property ext
        // ....
        this.updateExt();
    }

    addSubItem(inclusion) {
        inclusion.children.push({
            title: {
                en: '',
                zh: ''
            },
            content: {
                en: '',
                zh: ''
            }
        });
    }

    saveSubItem(subItem, index) {
        if (!subItem.title.en || !subItem.title.zh) {
            subItem.submitted = true;
            return;
        }
        subItem.saved = true;
        // update property ext
        // ....
        this.items.data.map(item => {
            delete item['saved'];
            delete item['submitted'];
            item.children.map(s => {
                delete s['saved'];
                delete s['submitted'];
            });
        });
        console.log(this.items);
        this.updateExt();
    }

    discardSubItem(item, subItem, index) {
        item.children.splice(index, 1);

    }

    deleteSubItem(item, subItem, index) {
        item.children.splice(index, 1);
        // update property ext
        // ....
        this.updateExt();
    }


    updateExt() {
        console.log(this.items);
        const fd = new FormData();
        fd.append('id', this.property.id);
        fd.append('ext', JSON.stringify(this.items));
        this.httpService.updateProperty(this.property.id, fd).subscribe((res: any) => {
            console.log(res);
            if (res.code === 1) {
                this.toastrService.success('Property has been updated');
            } else {
                this.toastrService.error('Failed to update property');
            }
            this.labelInclusionAsFromDB(this.items.data);
        });
    }

}
